<template>
  <div class="contract">
    <card-m
      :title="title"
      cardWidth="100%"
      cardHeight="100%"
      maxHeight="unset"
      toolWidth="100%"
      toolJustifyontent="flex-start"
      :show-filter="false"
      :show-export="true"
      :show-column-edit="true"
      export-file-name="合同列表"
      @export="handleExport"
      @edit-column="openColumnEdit"
    >
      <template v-if="showScheduleCard" slot="card-box2">
        <schedule-card />
      </template>   

      <template slot="card-box">
        <card-table
          tableID="contractTable"
          :key="tableRenderKey"
          :total="totalProgressCounts"
          :currentPage="currentProgressPage"
          @sizeChange="handleProgressSizeChanges"
          @currentChange="handleCurrentProgressChanges"
          :tableColumn="effectiveVisibleColumns"
          :tableData="contractProgressData"
          style="height: 100%; width: 100%;"
          :showIndex="true"
          @afterSalesClick="handleAftersaleClick"
          @column-width-change="onColumnWidthChange"
          :loading="loading"
          :showPaging="true"
          :size="progressPageSize"
          @contractLinkClick="handleContractLinkClick"
          :mobileColumns="mobileColumnEditFilter"
          @dateEditSave="handleDateEditSave"
          @textEditSave="handleTextEditSave"

          @column-filter-change="onColumnFilterChange"
          :columnFilterValues="columnFilterValues"
          @icon-click="handleStatusIconClick"
          @reviewProgressClick="handleReviewProgressClick"
          @tag-click="handleIssueTagClick"
        >
        </card-table>
      </template>

      <!-- <template slot="card-filter">
        <div class="filter-content">
          <div class="filter-item">
            <el-input
              placeholder="合同号"
              clearable
              size="mini"
              v-model="contractProgressSearchKeyword"
              suffix-icon="el-icon-search"
              @change="handleSearch"
            />
          </div>
        
        </div>
      </template> -->


    </card-m>

    <!-- 列编辑弹窗 -->
    <column-edit-dialog
      :visible.sync="columnEditVisible"
      :columns="tempOrderedColumns"
      :defaultColumns="effectiveDefaultColumnDefs"
      :title="columnEditTitle"
      :dialogWidth="columnEditDialogWidth"
      @confirm="handleColumnSave"
      @cancel="handleColumnCancel"
    />

    <!-- 评审进度暂存：统一气泡显示流程参与人 -->
    <el-popover
      placement="top"
      trigger="manual"
      v-model="reviewPopoverShow"
      append-to-body
      popper-class="review-participants-popover"
    >
      <div v-if="reviewPopoverContent" style="max-width:400px; word-break:break-all; padding:4px 8px; font-size:13px; line-height:1.6;">
        {{ reviewPopoverContent }}
      </div>
      <div v-else style="max-width:400px; padding:8px 12px; font-size:13px; color:#909399;">
        加载中...
      </div>
    </el-popover>

    <!-- 合同问题详情弹窗（点击「有无问题」列的「有」打开） -->
    <common-dialog-table
      :visible="issueDialogVisible"
      :title="'合同问题记录 - 合同编号: ' + currentContractNo"
      :tableColumn="issueListColumn"
      :tableData="issueList"
      @close="closeIssueDialog"
    />

    <!-- 合同异常详情弹窗（点击状态列红色圆点打开） -->
    <common-dialog-table
      :visible="exceptionDialogVisible"
      :title="'合同异常详情 - 合同编号: ' + currentExceptionContractNo"
      :tableColumn="exceptionListColumn"
      :tableData="exceptionList"
      @close="closeExceptionDialog"
    />
  </div>
</template>

<script>
import { UpdateDataList, getReviewStatus, getContractIssueList, getAbnormalInfo } from '@/api/mainapi.js';
import UserInfoUtils from '@/utils/userInfoUtils.js';
import columnEditMixin from '@/mixins/columnEditMixin';
import ColumnEditDialog from '@/components/ColumnEditDialog.vue';
import CommonDialogTable from '@/components/card/CommonDialogTable.vue';
import ScheduleCard from './ScheduleCard.vue';
import FileSaver from 'file-saver';
import XLSX from 'xlsx';

/* ✅ 状态列（数据状态码）的筛选选项：和 projectProgress / workOrderProgress 保持一致
   value 'true' 对应后端的 hasException = true；'' 为全部 */
const CONTRACT_EXCEPTION_OPTIONS = [
  { value: '', label: '全部' },
  { value: 'true', label: '有异常' }
];

export default {
  name: 'contractProgress',
  mixins: [columnEditMixin],

  props: {

    contractProgressData: { type: Array, default: () => [] },
    totalProgressCounts: { type: Number, default: 0 },
    loading: { type: Boolean, default: false },
    contractProgressSearchKeyword: { type: String, default: '' },
    progressPageSize: { type: Number, default: 50 },
    currentProgressPage: { type: Number, default: 1 },

    // ✅ 新增：是否显示 card-box2
    showScheduleCard: {
      type: Boolean,
      default: false
    },

    showFilterTool: {
      type: Boolean,
      default: true
    },

    title: {  
      type: String,
      default: '任务单主页'  
    },

  },
  components: {
    ScheduleCard,
    ColumnEditDialog,
    CommonDialogTable
  },

  computed: {
    /**
     * 合同执行反馈的编辑权限：仅 position='计划员' 或 isManagement='是'（isAdmin）可编辑，其他人仅查看
     */
    canEditExecuteFeedback() {
      // localStorage 里 isAdmin 由登录接口 isManagement === '是' 写入，position 为登录接口返回的职位
      return UserInfoUtils.getPosition() === '计划员' || UserInfoUtils.isAdmin();
    },

    baseColumnDefs() {
      // 执行反馈列的可编辑性随当前登录用户变化，在这里动态注入（列定义本身只声明一次）
      return this.contractProgressColumns.map(col => (
        col.prop === '合同执行反馈'
          ? { ...col, column: { ...col.column, editable: this.canEditExecuteFeedback } }
          : col
      ));
    }
  },

  data() {
    return {
      pageType: 'contractProgress',

      // ✅ 存列筛选值
      columnFilterValues: {},      
      contractProgressColumns: [
        
        {
          prop: '数据状态码',
          label: '状态',
          width: 50,
          // fixed: 'right',
          // // ✅ 和 projectProgress 一致：状态列支持「有异常」筛选
          // filterable: true,
          // filterType: 'select',
          // filterOptions: CONTRACT_EXCEPTION_OPTIONS,
          custom: true,
          column: {
            type: 'icon',
            icon: { default: 'status-circle' },
            tooltipField: '状态详情'
          }
        },
        {
          prop: '合同名称',
          label: '合同名称',
          filterable: true,
          // fixed: 'left',
          custom: true,
          column: {
            type: 'link',
            field: '合同名称',
            eventName: 'contractLinkClick'
          }
        },
        //   { 
        //   prop: '合同编号', 
        //   label: '合同编号',
        // },
        { 
          prop: '创建时间', 
          label: '创建时间',
          filterable: true,
          filterType: 'date'   // ✅ 已加
        },
        { 
          prop: '审核时间', 
          label: '审核时间',
          filterable: true,
          filterType: 'date'   // ✅ 已加
        },
        { 
          prop: '评审进度', 
          label: '评审进度',
          filterable: true,
          custom: true,
          column: {
            type: 'reviewLink',
            field: '评审进度',
            eventName: 'reviewProgressClick'
          }
        },
        { 
          prop: '客户', 
          label: '客户',
          filterable: true
        },
        { 
          prop: '销售员', 
          label: '销售员',
          filterable: true
        },
        { 
          prop: '更新日期', 
          label: '更新日期',
          filterable: true,
          filterType: 'dateSelect'
        },
        { 
          prop: '签订交货期', 
          label: '签订交货期',
          filterable: true,
          filterType: 'date'   // ✅ 新增
        },
        { 
          prop: '回复交货期', 
          label: '回复交货期',
          filterable: true,
          filterType: 'date'   // ✅ 新增
        },
        {
          prop: '计划完成时间',
          label: '预计交付时间',
          custom: true,
          column: {
            type: 'dateEdit',
            field: '计划完成时间',
            dateFormat: (date) => {
              if (!date) return '';
              if (typeof date === 'string' && date.length > 10) {
                return date.substring(0, 10);
              }
              return date;
            }
          }
        },
        { 
          prop: '交付进度', 
          label: '交付进度',
          filterable: true
        },
        {
          prop: '合同执行反馈',
          label: '合同执行反馈',
          custom: true,
          // editable 由 baseColumnDefs 按登录用户权限注入：计划员 / 管理员可编辑，其余仅查看
          column: {
            type: 'textEdit',
            field: '合同执行反馈',
            maxDisplayLength: 10
          }
        },
        { 
          prop: '网点号', 
          label: '网点号',
          filterable: true
        },
        { 
          prop: '销售金额', 
          label: '合同总额',
          filterable: true,
          filterPlaceholder: '不低于填入金额'
        },
        {
          prop: '回款比例',
          label: '回款比例',
          width: 100,
          filterable: true,
          filterPlaceholder: '请填入0-1之间的数',
          custom: true,
          column: { type: 'progress', field: '回款比例' }
        },
        { 
          prop: '售后总数量', 
          label: '售后次数',
          filterable: true,
          filterPlaceholder: '不低于填入次数'
        },
        {
          // 有无问题：hasIssue=true 显示「有」（红色，可点击查看问题详情），false 显示「无」（绿色）
          prop: 'hasIssue',
          label: '有无问题',
          width: 90,
          custom: true,
          column: {
            type: 'tag',
            clickable: true,
            tag: {
              'true': { text: '有', type: 'danger' },
              'false': { text: '无', type: 'success' }
            }
          }
        },
        {
          prop: '操作', 
          label: '操作',
          // fixed: 'right',
          width: 50,
          actions: [{ label: '售后', fnName: 'afterSalesClick' }]
        }
      ],

      // 手机端可用列 prop 过滤（供 mixin 保存/加载手机端列偏好）
      mobileColumnFilter: [
        '数据状态码',
        '合同名称',           // 合同号（你实际用的是合同名称）
        '评审进度',
        '交付进度',
        '销售金额',
        '操作'
      ],
      // 手机端列编辑弹窗中可编辑的全部列（恢复默认时，mobileColumnFilter 中的列打钩，其余取消打钩）
      mobileColumnEditFilter: [
        '数据状态码',
        '合同名称',
        '创建时间',
        '审核时间',
        '评审进度',
        '客户',
        '销售员',
        '更新日期',
        '签订交货期',
        '回复交货期',
        '计划完成时间',
        '交付进度',
        '合同执行反馈',
        '网点号',
        '销售金额',
        '回款比例',
        '售后总数量',
        'hasIssue',
        '操作',
      ],

      planDateEditDialog: {
        visible: false,
        contractNo: '',
        planDate: '',
        rowIndex: -1
      },

      // 评审进度-暂存：参与人气泡数据 { 合同编号: '参与人1,参与人2,...' }
      reviewParticipantsMap: {},
      // 评审进度-暂存：当前显示气泡的合同编号
      reviewPopoverVisible: {},

      // 合同问题详情弹窗
      issueDialogVisible: false,
      issueList: [],
      issueListColumn: [   // 直接用接口字段名（与产品问题列表一致）+ 合同维度多出的名称/型号/任务单号
        { prop: 'task_number', label: '任务单号' },
        { prop: 'serial_code', label: '产品编号' },
        { prop: 'name', label: '名称' },
        { prop: 'model', label: '型号' },
        { prop: 'create_time', label: '创建时间' },
        { prop: 'operation_person_name', label: '人员' },
        { prop: 'SHOWVALUE', label: '类型' },
        { prop: 'field0002', label: '问题' },
        { prop: 'detail', label: '备注' }
      ],
      currentContractNo: '',

      // ✅ 合同异常详情弹窗（点击状态列红色圆点）
      exceptionDialogVisible: false,
      exceptionList: [],
      currentExceptionContractNo: '',
      exceptionListColumn: [
        { prop: '项目编号', label: '项目编号' },
        { prop: '合同编号', label: '合同编号' },
        { prop: '任务号', label: '任务号' },
        { prop: '相关节点人', label: '相关节点人' },
        { prop: '异常类型', label: '异常类型' },
        { prop: '事件详情', label: '事件详情' },
        { prop: '发生时间', label: '发生时间' },
        { prop: '是否需要处理', label: '是否需要处理' },
        { prop: '处理人', label: '处理人' },
        { prop: '处理时间', label: '处理时间' },
        { prop: '解决时间', label: '解决时间' },
      ]
    };
  },

  async mounted() {
    await this.loadColumnPref();

    // 「合同执行反馈」是后来加的列：老用户已保存的列偏好里没有它，默认会被过滤掉，这里补成可见
    // （用户之后在列设置里隐藏过的话，columnOrderMap 里会有该列，就不会再强制显示）
    const prop = '合同执行反馈';
    if (!this.columnOrderMap.includes(prop)) {
      this.columnOrderMap.push(prop);
      this.checkedColumns.push(prop);
    }
    if (!this.mobileColumnOrderMap.includes(prop)) {
      this.mobileColumnOrderMap.push(prop);
    }
  },

  methods: {
  // ✅ 新增日期保存方法（inline 编辑）
  async handleDateEditSave(data) {
    const userCode = UserInfoUtils.getUserCode();
    if (!userCode) return;

    if (!data.row.合同名称) {
      this.$message.warning('合同号不能为空');
      return;
    }

    if (!data.value) {
      this.$message.warning('请选择计划完成时间');
      return;
    }

    try {
      const res = await UpdateDataList({
        Type: 'UpdatePlanDate',
        msg: JSON.stringify({
          planDate: data.value,
          updateBy: userCode
        }),
        contractNo: data.row.合同编号
      });

      if (res.data.code === 200) {
        this.$message.success('计划完成时间保存成功');
        
        // ✅ 前端同步
        if (data.index >= 0) {
          this.$set(
            this.contractProgressData[data.index],
            '计划完成时间',
            data.value
          );
        }
      } else {
        this.$message.error('保存失败：' + (res.data.message || '未知错误'));
      }
    } catch (error) {
      this.$message.error('网络错误，请检查连接');
    }
  },

  /** ✅ 合同执行反馈保存（inline 编辑）
   *  接口：api/dash/utils/update，Type=UpdateContractExecute
   *  Msg = { executeContent, updateBy, contractNo }
   */
  async handleTextEditSave(data) {
    // 无权限时表格里不会显示铅笔，这里再兜一层，防止绕过 UI 触发
    if (!this.canEditExecuteFeedback) {
      this.$message.warning('当前账号仅支持查看合同执行反馈');
      return;
    }

    const userCode = UserInfoUtils.getUserCode();
    if (!userCode) {
      this.$message.warning('未获取到登录工号，无法保存');
      return;
    }

    const contractNo = data.row.合同编号;
    if (!contractNo) {
      this.$message.warning('合同编号不能为空');
      return;
    }

    const value = data.value || '';
    if (value === (data.row.合同执行反馈 || '')) return; // 内容没变，不发请求

    try {
      const res = await UpdateDataList({
        Type: 'UpdateContractExecute',
        msg: JSON.stringify({
          executeContent: value,
          updateBy: userCode,
          contractNo
        })
      });

      if (res.data.code === 200) {
        this.$message.success('合同执行反馈保存成功');

        // ✅ 前端同步：必须用 data.row（与表格行同一对象），
        // 表格客户端排序后 data.index 是显示下标，用 index 会改到其他行
        this.$set(data.row, '合同执行反馈', value);
        // 同步更新 executeContent（更新人/更新时间），下次拉数据前界面上也是最新的
        const ec = data.row.executeContent;
        const now = this.formatNow();
        if (ec && typeof ec === 'object') {
          this.$set(ec, 'context', value);
          this.$set(ec, 'updateby', userCode);
          this.$set(ec, 'updatetime', now);
        } else {
          this.$set(data.row, 'executeContent', { context: value, updateby: userCode, updatetime: now });
        }
      } else {
        this.$message.error('保存失败：' + (res.data.message || '未知错误'));
      }
    } catch (error) {
      this.$message.error('网络错误，请检查连接');
    }
  },

  /** 当前时间 yyyy-MM-dd HH:mm:ss */
  formatNow() {
    const d = new Date();
    const p = n => (n < 10 ? '0' + n : '' + n);
    return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}:${p(d.getSeconds())}`;
  },


    /** ✅ 搜索 & 筛选 */
    handleSearch() {
      this.emitGetData();
    },
    emitGetData() {
      this.$emit('get-data', {
        contractNo: this.contractProgressSearchKeyword,
        currentPage: this.currentProgressPage,
        pageSize: this.progressPageSize,

        // ✅ 新增：列筛选值
        columnFilterValues: this.columnFilterValues
      });
    },

    /** ✅ 分页 */
    handleProgressSizeChanges(val) {
      this.$emit('get-data', {
        contractNo: this.contractProgressSearchKeyword,
        currentPage: this.currentProgressPage,
        pageSize: val
      });
    },
    handleCurrentProgressChanges(val) {
      this.$emit('get-data', {
        contractNo: this.contractProgressSearchKeyword,
        currentPage: val,
        pageSize: this.progressPageSize
      });
    },


    /** ✅ 其他事件 */
    handleAftersaleClick(data) {
          // data 来自 card-table 的 action 点击
      this.$emit('aftersale-click', data);
      // this.$router.push(`/homepage/aftersales?id=${data.合同名称}`);
      // this.$EventBus.$emit('currentPath', '/homepage/aftersales');
      // this.$EventBus.$emit('noContract', true);
    },

    handleContractLinkClick(data) {
          // data 来自 card-table 的 action 点击
      this.$emit('contractinfo-click', data);
      // this.$router.push(`/homepage/contract/${data.row.合同名称}`);
      // this.$EventBus.$emit('currentPath', `/homepage/contract/${data.row.合同名称}`);
    },

    // ✅ 评审进度-暂存点击：调用接口获取流程参与人
    async handleReviewProgressClick(data) {
      const contractNo = data.row.合同编号;
      if (!contractNo) {
        this.$message.warning('合同编号为空');
        return;
      }

      // 如果已经加载过，直接显示气泡
      if (this.reviewParticipantsMap[contractNo] !== undefined) {
        const participants = this.reviewParticipantsMap[contractNo];
        if (participants) {
          this.setRowReviewPopover(contractNo, participants, true);
        }
        return;
      }

      try {
        const res = await getReviewStatus({
          billNo: contractNo,
          PageSize: 999,
          status: '暂存'
        });

        if (res.data.code === 200) {
          const respData = res.data.data || {};

          // 收集所有流程参与人
          const participants = [];
          Object.keys(respData).forEach(key => {
            if (key.includes('流程参与人') && respData[key] && respData[key] !== '') {
              participants.push(respData[key]);
            }
          });

          if (participants.length > 0) {
            const participantsStr = participants.join(',');
            this.$set(this.reviewParticipantsMap, contractNo, participantsStr);
            this.setRowReviewPopover(contractNo, participantsStr, true);
          } else {
            // 无数据，记录为空，气泡显示无数据
            this.$set(this.reviewParticipantsMap, contractNo, '暂无数据');
            this.setRowReviewPopover(contractNo, '暂无数据', true);
          }
        } else {
          this.$message.error('获取参与人信息失败');
          this.clearRowReviewLoading(contractNo);
        }
      } catch (error) {
        this.$message.error('网络错误');
        this.clearRowReviewLoading(contractNo);
      }
    },

    // 同步更新行数据的参与人信息
    setRowReviewPopover(contractNo, participants, visible) {
      // 在 contractProgressData 中找到对应行并更新
      const idx = this.contractProgressData.findIndex(item => item.合同编号 === contractNo);
      if (idx >= 0) {
        this.$set(this.contractProgressData[idx], '_reviewParticipants', participants);
        this.$set(this.contractProgressData[idx], '_reviewPopoverVisible', visible);
        this.$set(this.contractProgressData[idx], '_reviewLoading', false);
      }
    },

    // 清除行的加载标记（接口失败时）
    clearRowReviewLoading(contractNo) {
      const idx = this.contractProgressData.findIndex(item => item.合同编号 === contractNo);
      if (idx >= 0) {
        this.$set(this.contractProgressData[idx], '_reviewLoading', false);
      }
    },

    /**
     * 「有无问题」列标签点击 - 查看该合同的问题详情
     * card-table 的 tag-click 事件：handleIssueTagClick(row, columnItem)
     */
    async handleIssueTagClick(row, columnItem) {
      // 只对「有无问题」列生效
      if (!columnItem || columnItem.prop !== 'hasIssue') return;
      // 无问题（hasIssue=false）不弹窗
      if (String(row.hasIssue) !== 'true') return;

      // 只传该行的合同编号，取不到就直接提示，不用其他字段兜底
      const contractNo = row.合同编号;
      if (!contractNo) {
        this.$message.warning('合同编号为空，无法查询问题记录');
        return;
      }
      this.currentContractNo = contractNo;

      try {
        // 合同维度问题详情：入参为该行的合同编号
        const res = await getContractIssueList({ contractNo: contractNo });

        const data = (res.data && res.data.data) || {};
        const rawList = data.list || [];

        if (res.data.code !== 200 || !rawList.length) {
          this.$message.info('该合同暂无问题记录');
          return;
        }

        // 列配置直接用接口字段名，这里原样透传即可
        this.issueList = rawList;
        this.issueDialogVisible = true;
      } catch (error) {
        this.$message.error('查询问题记录失败');
      }
    },

    /** 关闭问题详情弹窗 */
    closeIssueDialog() {
      this.issueDialogVisible = false;
      this.issueList = [];
      this.currentContractNo = '';
    },

    /** ✅ 状态图标点击 - 仅异常行（hasException = true，红色圆点）弹出异常详情
     *  与 projectProgress 一致，区别：传给后端的从 projectNo 换成 contractNo */
    async handleStatusIconClick({ row }) {
      // 仅当数据状态码为 0（异常）时响应
      if (row['数据状态码'] !== 0 && row['数据状态码'] !== '0') {
        return;
      }
      // 「评审进度 = 暂存无用」也是 0，但它不是异常，不弹窗
      if (!(row.hasException === true || row.hasException === 'true')) {
        this.$message.info('该合同暂无异常详情');
        return;
      }

      const contractNo = row['合同编号'];
      if (!contractNo) {
        this.$message.warning('该行没有合同编号');
        return;
      }

      this.currentExceptionContractNo = contractNo;

      try {
        const res = await getAbnormalInfo({
          taskNo: '',
          contractNo: contractNo,
          projectNo: ''
        });

        if (res.data.code === 200 && res.data.data && res.data.data.exceptionInfo) {
          const rawList = res.data.data.exceptionInfo;
          this.exceptionList = rawList.map(item => ({
            '项目编号': item['项目编号'] || '',
            '合同编号': item['合同编号'] || '',
            '任务号': item['任务号'] || '',
            '相关节点人': item['相关节点人'] || '',
            '异常类型': item['异常类型'] || '',
            '事件详情': item['事件详情'] || '',
            '发生时间': item['发生时间'] || '',
            '是否需要处理': item['是否需要处理'] || '',
            '处理人': item['处理人'] || '',
            '处理时间': item['处理时间'] || '',
            '解决时间': item['解决时间'] || '',
          }));
          this.exceptionDialogVisible = true;
        } else {
          this.$message.info('该合同暂无异常详情');
        }
      } catch (error) {
        this.$message.error('查询异常详情失败');
      }
    },

    /** 关闭异常详情弹窗 */
    closeExceptionDialog() {
      this.exceptionDialogVisible = false;
      this.exceptionList = [];
      this.currentExceptionContractNo = '';
    },



    /** 导出Excel */
    handleExport() {
      const xlsxParam = { raw: true };
      const wb = XLSX.utils.table_to_book(
        document.querySelector('#contractTable'),
        xlsxParam
      );
      const wbout = XLSX.write(wb, {
        bookType: 'xlsx',
        bookSST: true,
        type: 'array'
      });
      try {
        FileSaver.saveAs(
          new Blob([wbout], { type: 'application/octet-stream' }),
          '合同列表.xlsx'
        );
      } catch (e) {
        if (typeof console !== 'undefined') {
          console.log(e, wbout);
        }
      }
      return wbout;
    },

  // ✅ 列筛选变化处理
  onColumnFilterChange(filterValues) {
    // 将筛选值传递给父组件
    this.columnFilterValues = filterValues;
    this.$emit('column-filter-change', filterValues);

    // ✅ 筛选时重置到第一页，避免筛选后当前页无数据，强制分页组件重渲染
    this.tableRenderKey++;
    this.$emit('get-data', {
      contractNo: this.contractProgressSearchKeyword,
      currentPage: 1,
      pageSize: this.progressPageSize,
      columnFilterValues: this.columnFilterValues
    });
  },



  }
};
</script>



<style scoped lang="scss">
.contract {
  display: flex;
  flex-wrap: wrap;
  min-width: 350px;
  position: relative;
  width: 100%;
  // height: calc(100vh); /* 减去标题栏和间距的高度 */
  height: calc(100vh - 65px); /* 减去标题栏和间距的高度 */
  // min-height: 900px;

  flex-direction: column;
}
.search-box {
  width: 100%;
  min-width: 200px;
}

/* 修改列宽方向的padding（左右内边距） */
// .contract ::v-deep .card-table .el-table th {
//   padding: 0px 0px 0px 0px !important; /* 上 右 下 左 */
// }

// .contract ::v-deep .card-table .el-table td {
//   padding: 2px 0px 2px 0px !important; /* 上 右 下 左 */
// }

// .card-table {
//   /* 所有 .cell 的默认 padding */
//   ::v-deep .el-table .cell {
//     padding-left: 3px !important;
//     padding-right: 3px !important;
//     padding-top: 1px !important;
//     padding-bottom: 1px !important;
//     // min-width: 30px !important; /* 添加最小宽度，例如60px */
//   }
// }


::v-deep .card-m {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;   /* ⭐ 非常关键 */
  overflow: hidden;
}

::v-deep .card-box {
  flex: 1;
  min-height: 0;   /* ⭐ 非常关键 */
  overflow-y: hidden;
  overflow-x: hidden;
}

/* ================= 修复固定列滚动偏移 ================= */
/* 固定列行高必须与非固定列完全一致 */
.contract ::v-deep .el-table__fixed-body-wrapper .el-table__body td {
  padding: 0 !important;
}
.contract ::v-deep .el-table__fixed-body-wrapper .el-table__body td .cell {
  padding: 8px 2px 8px 1px !important;
  line-height: 1.2;
}

/* 固定列表头与普通表头统一高度 */
.contract ::v-deep .el-table__fixed-header-wrapper thead th {
  height: 36px !important;
  padding: 0 !important;
  background-color: rgba(37, 100, 207, 0.06) !important;
}
.contract ::v-deep .el-table__fixed-header-wrapper .el-table__header th .cell {
  padding: 4px 2px !important;
  font-family: "Microsoft YaHei", 微软雅黑, sans-serif;
  // font-size: 12px;
  font-weight: bold;
  line-height: 1.2;
  display: flex;
  align-items: center;
  height: 100%;
}

/* 在现有样式后添加 */
.filter-content {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
}

.filter-item {
  // min-width: 150px;
  flex: 1;
}

.statistic-range-selector {
  display: flex;
  align-items: center;
  
  .selector-label {
    font-size: 14px;
    color: #606266;
    margin-right: 8px;
    white-space: nowrap;
  }
  .el-select {
    min-width: 0;
  }
}

/* ✅ 手机端：整个双月日期选择器整体缩小 */
@media (max-width: 768px) {
  .contract {
    flex: 1 !important;
    min-height: 0 !important;
    height: 100% !important;
    display: flex !important;
    flex-direction: column !important;
  }

  ::v-deep .card-m {
    flex: 1 !important;
    min-height: 0 !important;
    display: flex !important;
    flex-direction: column !important;
  }

  ::v-deep .card-box {
    flex: 1 !important;
    min-height: 0 !important;
    display: flex !important;
    flex-direction: column !important;
  }

  ::v-deep .card-table {
    flex: 1 !important;
    min-height: 0 !important;
    display: flex !important;
    flex-direction: column !important;
  }

  ::v-deep .el-table {
    flex: 1 !important;
    display: flex !important;
    flex-direction: column !important;
    height: 100% !important;
  }

  ::v-deep .el-table__body-wrapper {
    flex: 1 !important;
    overflow-y: auto !important;
    min-height: 0 !important;
  }
}
</style>